import React from "react";
import {Link} from "react-router-dom";

//import assets
import "../../assets/styles/headerStyles/headerLogo.scss";
import {ReactComponent as Logo} from '../../assets/images/logo.svg';


export function HeaderLogo() {
    return <Link to={'/dashboard'} className="header-logo">
        <Logo/>
    </Link>
}
